module.exports = __webpack_public_path__ + "static/media/videothumb-default.31616bb8.svg";